import React from "react";

function UserResultPage({ userdata }) {
  const renderOptions = (questionData) => {
    if (!questionData.choices || questionData.choices.length === 0) {
      return null; // for text-type questions
    }

    return questionData.choices.map((option, index) => {
      const isCorrect = option.correct;

      // For boolean type, match "true"/"false" with "Yes"/"No"
      let isSelected;
      if (questionData.type === "boolean") {
        const boolValue = questionData.selectedOptions === "true";
        isSelected =
          (boolValue && option.text === "Yes") ||
          (!boolValue && option.text === "No");
      } else {
        isSelected = Array.isArray(questionData.selectedOptions)
          ? questionData.selectedOptions.includes(option.text)
          : questionData.selectedOptions === option.text ||
            questionData.selectedOptions === String(option.text);
      }

      let fillClass = isCorrect ? "correct" : "wrong";
      let icon = isCorrect ? "✅" : "❌";

      return (
        <div
          className={`option-bar ${isSelected ? "selected" : ""}`}
          key={index}
        >
          <div className={`option-fill ${fillClass}`}>
            <span className="option-label">
              {String.fromCharCode(65 + index)}. {option.text}
            </span>
            <span className="option-icon">{icon}</span>
          </div>
        </div>
      );
    });
  };

  const checkIfCorrect = (qdata) => {
    if (qdata.type === "text") {
      return qdata.selectedOptions?.trim() === qdata.correctAnswer?.trim();
    }
    if (qdata.type === "boolean") {
      // For boolean, convert "true"/"false" string to match with "Yes"/"No"
      const boolValue = qdata.selectedOptions === "true";
      const correctOption = (qdata.choices || []).find((c) => c.correct);
      if (!correctOption) return false;
      return (
        (boolValue && correctOption.text === "Yes") ||
        (!boolValue && correctOption.text === "No")
      );
    }
    if (qdata.type === "checkbox") {
      // For checkbox, selectedOptions might be a string or array
      const selectedArray = Array.isArray(qdata.selectedOptions)
        ? qdata.selectedOptions
        : [qdata.selectedOptions];

      const correctAnswers = (qdata.choices || [])
        .filter((c) => c.correct)
        .map((c) => c.text)
        .sort();
      const selected = [...selectedArray].sort();
      return JSON.stringify(correctAnswers) === JSON.stringify(selected);
    }
    // single choice (radiogroup, dropdown)
    const correctOption = (qdata.choices || []).find((c) => c.correct);
    return correctOption && qdata.selectedOptions == correctOption.text;
  };

  const getCorrectAnswer = (qdata) => {
    if (qdata.type === "text") return qdata.correctAnswer;
    return (qdata.choices || [])
      .filter((c) => c.correct)
      .map((c) => c.text)
      .join(", ");
  };

  return (
    <div className="result-card">
      <p>
        👤 <strong>User:</strong> {userdata.username}
      </p>
      <p>
        🏁 <strong>Score:</strong> {userdata.score} / {userdata.maxScore}
      </p>
      <p>
        ⏱️ <strong>Submitted At:</strong>{" "}
        {new Date(userdata.submittedAt).toLocaleString()}
      </p>

      {Object.entries(userdata.answers).map(([question, qdata], idx) => {
        const correct = checkIfCorrect(qdata);
        return (
          <div className="question-block" key={idx}>
            <div className="question-header">
              <div className="question-number">Q{idx + 1}</div>
              <div className="question-text">
                {question}
                {qdata.arabicTitle && (
                  <div className="question-text-arabic">
                    {qdata.arabicTitle}
                  </div>
                )}
              </div>
            </div>

            {/* Render choices if present */}
            <div className="options-block">{renderOptions(qdata)}</div>

            {/* Show user's selection */}
            <div className="selected-display">
              <span>You selected:</span>{" "}
              <strong>
                {qdata.type === "boolean"
                  ? qdata.selectedOptions === "true"
                    ? "Yes"
                    : "No"
                  : Array.isArray(qdata.selectedOptions)
                  ? qdata.selectedOptions.join(", ")
                  : qdata.selectedOptions || "None"}
              </strong>
            </div>

            {/* Always show correct answer */}
            <div className="correct-answer">
              ✅ Correct Answer: <strong>{getCorrectAnswer(qdata)}</strong>
            </div>

            {/* Per-question marks */}
            <div className="question-score">
              {correct ? "✔️ Score: 1 / 1" : "❌ Score: 0 / 1"}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default UserResultPage;
